import { render, staticRenderFns } from "./cardBag.vue?vue&type=template&id=f9e1b0c2&scoped=true&"
import script from "./cardBag.vue?vue&type=script&lang=js&"
export * from "./cardBag.vue?vue&type=script&lang=js&"
import style0 from "./cardBag.vue?vue&type=style&index=0&id=f9e1b0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e1b0c2",
  null
  
)

export default component.exports